<template>
    <paper class="collusion-warning-page">
        <el-tabs v-model="activeName" @tab-click="onTabClick">
            <el-tab-pane label="预警处理" name="first">
                <WarningHandle ref="warningHandleRef" />
            </el-tab-pane>
            <el-tab-pane label="预警详情" name="second">
                <WarningDetail ref="warningDetailRef"/>
            </el-tab-pane>
        </el-tabs>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import bigDataLog from '@/utils/bigDataLog';

export default {
    name: 'PerformanceCollusionWarning',
    components: {
        paper,
        WarningDetail: () => import('./WarningDetail/Index.vue'),
        WarningHandle: () => import('./WarningHandle/Index.vue')
    },
    data() {
        return {
            activeName: 'first'
        };
    },
    methods: {
        onTabClick(tab) {
            this.$nextTick(() => {
                // 埋点
                const MAP = {
                    first: 'bigData-btn-collusion-warning-handleTab',
                    second: 'bigData-btn-collusion-warning-detailTab'
                };
                const bigDataKey = MAP[this.activeName];
                if (bigDataKey) {
                    bigDataLog.sendDetailMessageByKey(bigDataKey);
                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
.collusion-warning-page {
    padding-top: 0px;

    ::v-deep .el-tabs__header {
        margin: 0 0 12px;
    }
}
</style>
